import { render } from "./Sammelpunkt.vue?vue&type=template&id=22941330&scoped=true"
import script from "./Sammelpunkt.vue?vue&type=script&lang=js"
export * from "./Sammelpunkt.vue?vue&type=script&lang=js"

import "./Sammelpunkt.vue?vue&type=style&index=0&id=22941330&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22941330"]])

export default __exports__